/**
 * 与表 meter_energy_record.fee_type、category 约定一致（后端/统计共用）
 */
export const FEE_TYPE_OPTIONS = [
  { label: '电', value: 1 },
  { label: '水', value: 2 },
  { label: '暖', value: 3 },
  { label: '污水', value: 4 }
]

export const CATEGORY_BY_FEE = {
  1: ['翻车机用电', '储备煤用电', '生活用电'],
  2: ['工业用水', '中卫热电用水', '生活用水'],
  3: ['暖气'],
  4: ['园区污水处理', '中卫热电污水处理']
}

export function feeTypeLabel(v) {
  const o = FEE_TYPE_OPTIONS.find((x) => x.value === v)
  return o ? o.label : String(v)
}
